import * as React from 'react'
import { useEffect, useState } from 'react'
import { List } from '@mui/material'
import { useTranslation } from 'react-i18next'
import homeIcon from '../../assets/new-left-menu/home.svg'
import iconPatient from '../../assets/new-left-menu/patients.svg'
import iconProfesional from '../../assets/left_menu/profesional-icon.svg'
import iconNews from '../../assets/new-left-menu/news.svg'
import iconResources from '../../assets/new-left-menu/resources.svg'
import iconCalendar from '../../assets/left_menu/icono-calendario.svg'
import iconTraining from '../../assets/new-left-menu/training.svg'
import iconConsultas from '../../assets/new-left-menu/consultas.svg'
import styles from '../header/Header.module.css'
import { ILoggedUserService } from '../../modules/users/services/LoggedUserService'
import { LOGGED_USER_SERVICE_KEY, USER_SERVICE_KEY } from '../../modules/users'
import { getUserContainer } from '../../container/user-module'
import { User } from '../../modules/users/models/User'
import { UserService } from '../../modules/users/services/UserService'
import ListElement from './ListElement'

type ListItemsProps = {
  handleClick: (type: string) => void
  isOpen: boolean
  setOpen: (b: boolean) => void
}

const userContainer = getUserContainer()
const loggedUserService = userContainer.get<ILoggedUserService>(LOGGED_USER_SERVICE_KEY)
const userService = userContainer.get<UserService>(USER_SERVICE_KEY)

const ListItems = (props: ListItemsProps) => {
  const { t } = useTranslation()
  const [user, setUser] = useState<User>()
  const [activeItem, setActiveItem] = useState<string>(window.location.pathname)
  const trainingPath = user?.roles.includes('patient') ? '/training' : '/trainings'
  const loggedUser = loggedUserService.get()

  useEffect(() => {
    if (!loggedUser?.id) return
    userService.getByID(loggedUser.id).subscribe((res) => {
      setUser(res)
    })
  }, [loggedUser])

  const handleItemClick = (path: string, clickValue: string) => {
    setActiveItem(path)
    props.handleClick(clickValue)
  }

  return (
    <List
      className={
        window.innerWidth > 900
          ? user && user.roles.includes('admin')
            ? `${styles.listContainer} ${styles.adminListContainer}`
            : styles.listContainer
          : styles.listContainerResponsive
      }
    >
      {user && user.roles.includes('admin') && (
        <>
          <ListElement
            icon={iconConsultas}
            itemText={t('professionals')} // Pasamos directamente el texto traducido
            active={activeItem === '/profesionals'}
            onClick={() => handleItemClick('/profesionals', 'PROFESIONALS')}
          />
          <ListElement
            icon={iconPatient}
            itemText={t('residents')}
            active={activeItem === '/patients'}
            onClick={() => handleItemClick('/patients', 'PATIENTS')}
          />
          <ListElement
            icon={iconProfesional}
            itemText={t('medicines')}
            active={activeItem === '/medicines'}
            onClick={() => handleItemClick('/medicines', 'MEDICINES')}
          />
          <ListElement
            icon={iconTraining}
            itemText={t('training')}
            active={activeItem === trainingPath}
            onClick={() => handleItemClick(trainingPath, 'TRAINING')}
          />
        </>
      )}

      {user && user.roles.includes('medExtern') && (
        <>
          <ListElement
            icon={iconPatient}
            itemText={t('appointments')}
            active={activeItem === '/externAppointments'}
            onClick={() => handleItemClick('/externAppointments', 'EXTERN-APPOINTMENTS')}
          />
          <ListElement
            icon={iconCalendar}
            itemText={t('calendar')}
            active={activeItem === '/calendar/external'}
            onClick={() => handleItemClick('/calendar/external', 'EXTERN-CALENDAR')}
          />
        </>
      )}

      {user && user.roles.includes('med') && (
        <>
          <ListElement
            icon={homeIcon}
            itemText={t('start')}
            active={activeItem === '/newsWall'}
            onClick={() => handleItemClick('/newsWall', 'START')}
          />

          <ListElement
            icon={iconPatient}
            itemText={t('residents')}
            active={activeItem === '/patients'}
            onClick={() => handleItemClick('/patients', 'PATIENTS')}
          />

          <ListElement
            icon={iconNews}
            itemText={t('news')}
            active={activeItem === '/articles'}
            onClick={() => handleItemClick('/articles', 'NEWS')}
          />

          <ListElement
            icon={iconResources}
            itemText={t('resources2')}
            active={activeItem === '/resources'}
            onClick={() => handleItemClick('/resources', 'RESOURCES')}
          />

          <ListElement
            icon={iconCalendar}
            itemText={t('calendar')}
            active={activeItem === '/calendar'}
            onClick={() => handleItemClick('/calendar', 'SURVEYS')}
          />
        </>
      )}
    </List>
  )
}

export default ListItems
